import { USER_PROFILES, MESSAGE_TYPES } from './constants';
import { AuthManager } from './authManager';
import { AdminHandlers } from './handlers/adminHandlers';
import { AgentHandlers } from './handlers/agentHandlers';

export class SocketMessageHandler {
  constructor(dispatch) {
    this.dispatch = dispatch;
  }

  async handleMessage(message, user, update) {
    const messageType = message?.metadata?.type;

    if (!messageType) {
      console.warn('Mensagem recebida sem tipo:', message);
      return Promise.resolve(); // retorna sempre algo
    }

    if (messageType === MESSAGE_TYPES.TOKEN_EXPIRATION) {
      return AuthManager.handleTokenExpiration(message.data);
    }

    if (SocketMessageHandler.isAdminUser(user)) {
      await this.handleAdminMessages(messageType, message, user);
    }

    if (SocketMessageHandler.isAgentUser(user)) {
      await this.handleAgentMessages(messageType, message, user, update);
    }

    return Promise.resolve(); // garante retorno em todos os caminhos
  }

  async handleAdminMessages(messageType, message, user) {
    const service = SocketMessageHandler.getService(user, message.metadata?.serviceId);

    if (!service && SocketMessageHandler.requiresService(messageType)) {
      return;
    }

    const adminHandlers = {
      [MESSAGE_TYPES.WHATSAPP_QR_CODE_CHANGE]: () => AdminHandlers.handleWhatsAppQrCode(message, user),

      [MESSAGE_TYPES.SERVICE_STATUS_UPDATE]: () => AdminHandlers.handleServiceStatusUpdate(message, user),

      [MESSAGE_TYPES.USER_CONNECTED]: () => AdminHandlers.handleUserEvents(this.dispatch, user),

      [MESSAGE_TYPES.USER_DISCONNECTED]: () => AdminHandlers.handleUserEvents(this.dispatch, user),

      [MESSAGE_TYPES.USER_BREAK_START]: () => AdminHandlers.handleUserEvents(this.dispatch, user),

      [MESSAGE_TYPES.USER_BREAK_END]: () => AdminHandlers.handleUserEvents(this.dispatch, user),

      [MESSAGE_TYPES.DASHBOARD_UPDATE]: () => AdminHandlers.handleDashboardUpdate(this.dispatch, user),

      [MESSAGE_TYPES.CHAT_ASSIGNMENT]: () => AdminHandlers.handleChatAssignmentAdmin(this.dispatch, message),

      [MESSAGE_TYPES.CHAT_TRANSFER]: () => AdminHandlers.handleChatTransferAdmin(this.dispatch, message),

      [MESSAGE_TYPES.CHAT_FINALIZATION]: () => AdminHandlers.handleChatFinalizationAdmin(this.dispatch, message),

      [MESSAGE_TYPES.PABX_STATE_UPDATE]: () => AdminHandlers.handlePabxStateUpdate(this.dispatch, message),
    };

    const handler = adminHandlers[messageType];
    if (handler) {
      await handler();
    }
  }

  async handleAgentMessages(messageType, message, user, update) {
    const agentHandlers = {
      [MESSAGE_TYPES.CHAT_TRANSFER]: () => AgentHandlers.handleChatTransfer(this.dispatch, message, user),

      [MESSAGE_TYPES.CHAT_ASSIGNMENT]: () => AgentHandlers.handleChatAssignment(this.dispatch, message, user),

      [MESSAGE_TYPES.INCOMING_MESSAGES]: () => AgentHandlers.handleIncomingMessages(this.dispatch, message, user),

      [MESSAGE_TYPES.MESSAGE_UPDATE]: () => AgentHandlers.handleMessageUpdate(this.dispatch, message),

      [MESSAGE_TYPES.CHAT_FINALIZATION]: () => AgentHandlers.handleChatFinalization(this.dispatch, message, user),

      [MESSAGE_TYPES.VIDEO_SCHEDULE]: () => AgentHandlers.handleVideoSchedule(this.dispatch, message),

      [MESSAGE_TYPES.USER_BREAK_START]: () => AgentHandlers.handleUserStatusUpdate(message, user, update),

      [MESSAGE_TYPES.USER_BREAK_END]: () => AgentHandlers.handleUserStatusUpdate(message, user, update),

      [MESSAGE_TYPES.USER_WAITING_FOR_PAUSE]: () => AgentHandlers.handleUserStatusUpdate(message, user, update),

      [MESSAGE_TYPES.USER_CANCEL_WAITING_FOR_PAUSE]: () => AgentHandlers.handleUserStatusUpdate(message, user, update),
    };
    const handler = agentHandlers[messageType];
    if (handler) {
      await handler();
    }
  }

  static isAdminUser(user) {
    return user?.acl?.profile && USER_PROFILES.ADMIN_PROFILES.includes(user.acl.profile);
  }

  static isAgentUser(user) {
    return user?.acl?.profile && USER_PROFILES.AGENT_PROFILES.includes(user.acl.profile);
  }

  static getService(user, serviceId) {
    return user?.services?.find((service) => service._id === serviceId);
  }

  static requiresService(messageType) {
    return [MESSAGE_TYPES.WHATSAPP_QR_CODE_CHANGE, MESSAGE_TYPES.SERVICE_STATUS_UPDATE].includes(messageType);
  }
}

// Função principal exportada (compatibilidade com código existente)
export const OnConnectCompany = async (message, user, dispatch, update) => {
  const handler = new SocketMessageHandler(dispatch);
  await handler.handleMessage(message, user, update);
};
